// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.author-info_author-info_B7ly5 {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: default;
}

.author-info_avatar_O33BK {
  margin-right: 0.5625rem;
}

.author-info_project-title_Cu_ip {
  max-width: 12rem;
  display: block;
  overflow: hidden;
  font-size: 0.875rem;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  padding: 0;
}

.author-info_username-line_yppns {
  max-width: 12rem;
  font-size: 0.75rem;
  display: block;
  overflow: hidden;
  font-weight: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.author-info_username_kYALY {
  font-weight: bold;
}

.author-info_link__vpRp {
  text-decoration: none;
  color: var(--menu-bar-foreground) !important;
}

.author-info_link__vpRp:hover {
  text-decoration: underline;
}

.author-info_link__vpRp .author-info_author-info_B7ly5 {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/author-info.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;EACE,2DAA2D;EAC3D,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.author-info {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: default;\n}\n\n.avatar {\n  margin-right: 0.5625rem;\n}\n\n.project-title {\n  max-width: 12rem;\n  display: block;\n  overflow: hidden;\n  font-size: 0.875rem;\n  font-weight: bold;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 0;\n  padding: 0;\n}\n\n.username-line {\n  max-width: 12rem;\n  font-size: 0.75rem;\n  display: block;\n  overflow: hidden;\n  font-weight: normal;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.username {\n  font-weight: bold;\n}\n\n.link {\n  text-decoration: none;\n  color: var(--menu-bar-foreground) !important;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n.link .author-info {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"author-info": `author-info_author-info_B7ly5`,
	"authorInfo": `author-info_author-info_B7ly5`,
	"avatar": `author-info_avatar_O33BK`,
	"project-title": `author-info_project-title_Cu_ip`,
	"projectTitle": `author-info_project-title_Cu_ip`,
	"username-line": `author-info_username-line_yppns`,
	"usernameLine": `author-info_username-line_yppns`,
	"username": `author-info_username_kYALY`,
	"link": `author-info_link__vpRp`
};
export default ___CSS_LOADER_EXPORT___;
